// React
import React, { useState, useEffect, useRef } from 'react';

// Prime React
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Planner functions
import { formatDate, getEmployeeLink, getTravellerLink, getProductHTML, getOrderLink, getEditButton } from '../planner/planner';

export function SuggestionsTable(props) {
	const [expandedRows, setExpandedRows] = useState([]);

	// List of all possible columns
	let columns = [
		{
			name: 'date_reported',
			header: 'Reported Date',
			sortable: false,
			output: getDate
		},
		{
			name: 'reported_by',
			header: 'Reported By',
			sortable: false,
			output: getReportedBy
		},
		{
			name: 'status',
			header: 'Status',
			sortable: false,
			output: getStatus
		},
		{
			name: 'category',
			header: 'Category',
			sortable: false,
			output: getCategory
		},
		{
			name: 'product',
			header: 'Product',
			sortable: false,
			output: getProduct
		},
		{
			name: 'product_qty',
			header: 'Quantity',
			sortable: false,
			output: getProductQty
		},
		{
			name: 'traveller',
			header: 'Traveller #',
			sortable: false,
			output: getTraveller
		},
		{
			name: 'order',
			header: 'Order #',
			sortable: false,
			output: getOrder
		},
		{
			name: 'view_button',
			header: '',
			sortable: false,
			output: getButton
		},
	]

	/**
	 * Format the reported date for the scrap
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The formatted date and time
	 */
	function getDate(rowData) {
		return formatDate(rowData.date_reported, true);
	}

	/**
	 * Get the reported by user
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The reported by user
	 */
	function getReportedBy(rowData) {
		return getEmployeeLink(rowData.reported_by_user_id, rowData.reported_by_display_name, props.capabilities)
	}

	/**
	 * Format the status for the scrap
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The formatted date and time
	 */
	function getStatus(rowData) {
		return <div className={"badge bg-planner-scrap-" + rowData.status_label.toLowerCase()}>{rowData.status_label}</div>;
	}

	/**
	 * Get a badge for the fault of the scrap
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The fault inside of a badge of the scrap
	 */
	function getCategory(rowData) {
		let classColour = 'primary';

		if(rowData.suggestion_cat_name === 'Uncategorised') {
			classColour = 'danger';
		}

		return <div className={"badge bg-" + classColour}>{rowData.suggestion_cat_name}</div>
	}

	/**
	 * Get HTML for the product information
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} Product information with a tooltip description
	 */
	function getProduct(rowData) {
		return getProductHTML(rowData.product_id, rowData.product_sku, rowData.product_description, props.capabilities, rowData.product_qty)
	}

	/**
	 * Get HTML for the product information
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} Product information with a tooltip description
	 */
	function getProductQty(rowData) {
		return rowData.product_qty;
	}

	/**
	 * Get the traveller number and link if user has capability to view travellers
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The traveller ID with a clickable link to go to that traveller page
	 */
	function getTraveller(rowData) {
		return getTravellerLink(rowData.traveller_id, rowData.traveller_number, props.capabilities)
	}

	/**
	 * Get the order number and link if user has capability to view orders
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns if users can read jobs, output html link to the job
	 */
	function getOrder(rowData) {
		return getOrderLink(rowData.order_id, rowData.order_number, props.capabilities)
	}

	/**
	 * Get the edit button for the scrap
	 * 
	 * @param {Object} rowData The data associated to the row
	 * @returns {html} The edit button for the scrap
	 */
	function getButton(rowData) {
		return getEditButton("/suggestion/" + rowData.id);
	}

	function getSuggestion(rowData) {
		return rowData.suggestion;
	}

	return (
		<DataTable value={props.suggestions} expandedRows={expandedRows} rowExpansionTemplate={getSuggestion} onRowToggle={(e) => setExpandedRows(e.data)}>
			<Column expander={true} style={{ width: '3rem' }} />
			<Column key="suggestion_number" field="suggestion_number" header="Suggestion #" sortable={false} />
			{
				columns.map(column => {
					return props.columns.includes(column.name) && (
						<Column key={column.name} field={column.name} header={column.header} sortable={column.sortable} body={column.output} />
					)
				})
			}
		</DataTable>
	)
}